import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useSnackbar } from "notistack";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import AdminService from "../services/AdminService";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import PublicService from "../services/PublicService";
import getUserFriendlyMessages from "../genericFunctions/getUserFriendlyMessages";
import getDisplayTranslation from "../genericFunctions/getDisplayTranslation";
import { CREATED } from "../genericFunctions/operationTypeConstants";
import { getProfileLanguageName } from "../genericFunctions/profileLanguages";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const VersionManager = (props) => {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const { id } = props.match.params;
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [message, setMessage] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [version, setVersion] = useState({ name: "", sourceLanguage: "" });
  const [consultant, setConsultant] = useState({});

  const translations = consultant.translations || [];

  const onChange = (e) => {
    setVersion({ ...version, [e.target.name]: e.target.value });
  };

  const openDialog = () => {
    const displayTranslation = getDisplayTranslation(translations);
    setVersion({
      name: "",
      sourceLanguage: displayTranslation ? displayTranslation.language : "",
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const saveAndContinue = (e) => {
    e.preventDefault();
    setFetching(true);

    AdminService.createProfileVersion(id, version.name, version.sourceLanguage)
      .then((data) => {
        const { message } = data;
        if (!message.msgError) {
          PublicService.getConsultant(id).then((data) => {
            if (data && data.user) {
              setConsultant(data.user);
              setFetching(false);
              setMessage(
                getUserFriendlyMessages(
                  CREATED,
                  "a new version of consultant profile"
                )
              );
            }
          });
        } else if (message.msgBody === "Unauthorized") {
          setMessage(message);
          authContext.setUser({ username: "", role: "" });
          authContext.setIsAuthenticated(false);
        } else {
          setMessage(message);
        }
      })
      .catch((err) => {
        setFetching(false);
        if (err && err.data && err.data.message) {
          setMessage(err.data.message);
        }
      });
    setOpen(false);
  };

  useEffect(() => {
    if (message !== null) {
      enqueueSnackbar(message.msgBody, {
        variant: message.msgError ? "error" : "info",
      });
    }
    setTimeout(() => {
      setMessage(null);
    }, 3000);
  }, [message]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    PublicService.getConsultant(id).then((data) => {
      if (data && data.user) {
        setConsultant(data.user);
        setLoading(false);
      }
    });
  }, [id]);

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Name new version"}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={saveAndContinue}>
            <TextField
              type="text"
              name="name"
              label="Version name"
              value={version.name}
              onChange={onChange}
              className="form-cotrol"
              variant="outlined"
              placeholder="Enter a name for this version"
              style={{ margin: "0px 0px 10px 0px", width: "100%" }}
            />
            <TextField
              select
              name="sourceLanguage"
              label="Create from"
              value={version.sourceLanguage}
              onChange={onChange}
              className="form-cotrol"
              variant="outlined"
              style={{ margin: "0px 0px 10px 0px", width: "100%" }}
            >
              {translations.map((translation) => (
                <MenuItem
                  key={translation.language}
                  value={translation.language}
                >
                  {getProfileLanguageName(translation.language)}
                </MenuItem>
              ))}
            </TextField>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                margin: "5% 0%",
              }}
            >
              <Button
                type="submit"
                variant="outlined"
                color="primary"
                style={{ margin: "5px" }}
              >
                Create
              </Button>
              <Button
                onClick={handleClose}
                variant="outlined"
                color="secondary"
                style={{ margin: "5px" }}
              >
                Cancel
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
      {loading && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "15%",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      )}
      {!loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              margin: "20px",
              width: "75%",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                borderBottom: "1px solid #e1e1e1",
                paddingBottom: "15px",
              }}
            >
              <IconButton onClick={() => history.push(`/consultantpage/${id}`)}>
                <ArrowBackIcon />
              </IconButton>
              <div
                style={{
                  display: "flex",
                  width: "50%",
                  justifyContent: "center",
                }}
              >
                <div>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "white",
                      backgroundColor: "#13222D",
                      width: "170px",
                    }}
                    onClick={openDialog}
                    disabled={translations.length === 0}
                  >
                    <AddIcon style={{ marginRight: "10px" }} /> New version
                  </Button>
                  {fetching && (
                    <CircularProgress
                      color="secondary"
                      size={20}
                      style={{ margin: "0px 0px -5px 15px" }}
                    />
                  )}
                </div>
              </div>
              <ArrowBackIcon style={{ color: "#FAFAFA" }} />
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                margin: "20px",
                justifyContent: "center",
              }}
            >
              {consultant.profileVersions.map((version) => (
                <Paper
                  key={version._id}
                  elevation={3}
                  onClick={() =>
                    history.push(`/versioneditor/${id}/${version._id}`)
                  }
                  style={{
                    padding: "20px",
                    color: "white",
                    backgroundColor: "#13222D",
                    width: "200px",
                    height: "200px",
                    textAlign: "center",
                    margin: "10px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <h5 style={{ marginTop: "45px" }}>{version.name}</h5>
                  <p style={{ margin: "0px", fontSize: "90%" }}>
                    {getProfileLanguageName(version.language)}
                  </p>
                  <div
                    style={{
                      height: "150px",
                      display: "flex",
                      alignItems: "flex-end",
                      marginBottom: "0px",
                    }}
                  >
                    <img
                      alt="Drakryggen logo"
                      src={
                        `/images/dr_logo.png` ||
                        `http://localhost:5000/images/dr_logo.png
                `
                      }
                      style={{
                        height: "50px",
                      }}
                    />
                  </div>
                </Paper>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VersionManager;
